import { Plugin } from 'prosemirror-state';

import { BaseExtension, EditorOptions, EditorView, extensionType } from '@lyearn/lygo-core';

import { getCurrentSelectionNode } from '../../utils';
import { backspaceKeypressEnum } from './consts';

export default class HandleBackSpaceKey extends BaseExtension {
  get type(): string {
    return extensionType.toolbar;
  }

  get name(): string {
    return 'handle_backspace';
  }

  plugins(_editorOptions: EditorOptions) {
    return [
      new Plugin({
        props: {
          handleDOMEvents: {
            keydown: (view: EditorView, event: KeyboardEvent) => {
              if (_editorOptions.isMicroLearning) {
                // For micerolearning, we want to ignore key down event
                event.preventDefault();
                return true;
              }
              if (event.key === 'Backspace' || event.key === 'Delete') {
                const { empty } = view.state.selection;

                if (!empty) {
                  return false;
                }

                const backspaceKeyNodes = Object.keys(backspaceKeypressEnum)
                  // @ts-ignore
                  .map((key) => backspaceKeypressEnum[key]);
                const currentSelectionNode = getCurrentSelectionNode(view, view.state.selection.to);
                if (
                  currentSelectionNode &&
                  backspaceKeyNodes.includes(currentSelectionNode.type.name) &&
                  currentSelectionNode.content.size === 0
                ) {
                  // Replace the block with pragraph of content " " as
                  // backspace keymap from the basekeymap would delete
                  // one character.
                  view.dispatch(
                    view.state.tr.replaceSelectionWith(
                      view.state.schema.node(
                        view.state.schema.nodes.paragraph,
                        {},
                        view.state.schema.text(' '),
                      ),
                      false,
                    ),
                  );
                  return true;
                }
              }
              return false;
            },
          },
        },
      }),
    ];
  }
}
